/**
 * @file
 * Main JavaScript entry point for fluxo theme.
 */

// Import Tailwind CSS
import '../tailwind/input.css';

// Add your JavaScript code here
// Example:
// import './components/example.js';

// Drupal behaviors
(function (Drupal) {
  'use strict';

  /**
   * Attach behaviors.
   */
  Drupal.behaviors.fluxo = {
    attach: function (context, settings) {
      // Add your Drupal behaviors here
      // This runs when Drupal attaches behaviors
    },
  };
})(Drupal);
